import React, { useState, useEffect } from 'react';
import './ModelViewerComponent.css'; // Import your CSS file with the styles

const ModelViewerComponent = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Simulate a loading delay (you can replace this with actual loading logic)
    const loadingTimeout = setTimeout(() => {
      setIsLoaded(true);
    }, 2000); // 2 seconds (adjust as needed)

    // Cleanup the timeout if the component unmounts before it's loaded
    return () => clearTimeout(loadingTimeout);
  }, []);

  return (
    <div className="centered-container">
      {!isLoaded ? (
        <div className='modell__text'>Loading...</div>
      ) : (
        <model-viewer
          alt="react_logo"
          src="images/react_logo_circle/react.gltf"
          camera-controls
          disable-zoom
        ></model-viewer>
      )}
    </div>
  );
};

export default ModelViewerComponent;
